export default "__VITE_ASSET__87f9b939__"